import { CustomerBillerStatus } from '../../billers/models/customer-biller-status.model';
import { SafeHtml } from '@angular/platform-browser';

export function mapCustomerBillerStatusToSnackBarData(
  customerBillerStatus: CustomerBillerStatus,
  additionalData?: NewCustomerBIllerInfoSnackBarParams,
): NewCustomerBillerInfoSnackBarData {
  switch (customerBillerStatus) {
    case CustomerBillerStatus.ENABLED:
      if (additionalData?.hasPayableLiabilities) {
        return {
          icon: 'check_circle_filled',
          bodyTemplate: 'Opłaty od wybranego dostawcy zostały pomyślnie dodane.',
        };
      } else {
        return {
          icon: 'info',
          title: 'Brak bieżących opłat',
          bodyTemplate: `Dostawca został pomyślnie dodany,
          ale nie odnotowaliśmy rachunków do opłacenia. Dodaj kolejnego dostawcę, aby wykonać płatność.`,
          ctaButton: 'Dodaj',
        };
      }
    case CustomerBillerStatus.INVALID:
      return {
        icon: 'error_filled',
        bodyTemplate: 'Nieprawidłowe dane do logowania.',
        ctaButton: 'POPRAW',
      };
    case CustomerBillerStatus.FOLLOW_UP_CREDENTIALS_REQUIRED:
      return {
        icon: 'error_filled',
        bodyTemplate: 'Wymagane podanie kodu OTP.',
        ctaButton: 'KONFIGURUJ',
      };
    case CustomerBillerStatus.INVALID_FOLLOW_UP_CREDENTIALS:
      return {
        icon: 'error_filled',
        bodyTemplate: 'Nieprawidłowy kod OTP.',
        ctaButton: 'POPRAW',
      };
    case CustomerBillerStatus.USER_ACTION_NEEDED:
      return {
        icon: 'error_filled',
        title: 'Nie udało się pobrać opłat',
        bodyTemplate:
          additionalData?.userActionNeeded ||
          `Pobranie opłat nie było możliwe, ponieważ w eBOK wymagana jest Twoja akcja.
          Zaloguj się do panelu dostawcy i postępuj zgodnie z komunikatami na ekranie.`,
      };
    default:
      return;
  }
}

export const TIMEOUT_SNACKBAR_DATA: NewCustomerBillerInfoSnackBarData = {
  icon: 'info',
  title: 'Dodawanie opłaty trwa dłużej niż zwykle',
  bodyTemplate: `Możesz w międzyczasie dodać kolejnego dostawcę a my poinformujemy Cię gdy obecny proces się zakończy.`,
  ctaButton: 'Dodaj dostawcę',
};

export interface NewCustomerBIllerInfoSnackBarParams {
  hasPayableLiabilities?: boolean;
  userActionNeeded?: string | SafeHtml;
}

export interface NewCustomerBillerInfoSnackBarData {
  title?: string;
  bodyTemplate: string | SafeHtml;
  ctaButton?: string;
  disableCloseButton?: boolean;
  icon: IconType;
}

export type IconType = 'check_circle_filled' | 'info' | 'error_filled';
